import router from './index';

// States
import fourofour from '../views/404/state';
import DashboardPage from '../views/accounts/state';
import AccountPage from '../views/account/state';
import AccountsPage from '../views/dashboard/state';
import NewFormAccount from '../views/new-form-account/state';
import NewChatAccount from '../views/new-chat-account/state';
import WidgetAnalytics from '../views/widget-analytics/state';

const states = [
    fourofour,
    DashboardPage,
    AccountsPage,
    AccountPage,
    NewFormAccount,
    NewChatAccount,
    WidgetAnalytics,
];

// Register states
states.forEach(state => router.stateRegistry.register(state));

export default router;
